import styled from 'styled-components'

import { flexboxGapStyles } from '../../../../../../../lib/styles/flexbox-gap'
import OptionalProductLink from '../../../../../../OptionalProductLink'

export const ProductListEntry = styled.div`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  padding: 14px;
  overflow: hidden;
  margin-bottom: 16px;
`

export const GapContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  // use negative margins to workaround lack of flexbox gap support in older browsers
  ${flexboxGapStyles('10px')};
`

export const ItemDetails = styled.div`
  display: flex;
  overflow: hidden;
  flex-wrap: nowrap;
  min-width: 320px;
  flex: 1 0 320px;
  align-items: center;
`

export const ItemImage = styled.img`
  align-self: flex-start;
  border-radius: 4px;
  height: 115px;
  width: 115px;
  min-width: 115px;
  object-fit: contain;
  margin-right: 16px;
`

export const ItemName = styled.div`
  max-width: 320px;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  line-height: 1.43;
`

export const ItemSku = styled.div`
  font-size: 10px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.grayscale.gray40};
`

export const ItemAttribute = styled.div`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-size: 12px;
  line-height: 1.67;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-evenly;
  @media (min-width: 425px) {
    width: unset;
    justify-content: space-between;
    flex-direction: column;
  }
  .icon {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.coolGray.cool450};
    &:hover {
      color: ${({ theme }) => theme.colors.coolGray.cool600};
    }
    width: 25px;
    height: 25px;
    padding: 6px;
  }
  .green {
    color: darkseagreen;
  }
`

export const Container = styled.div`
  overflow: hidden;
`

export const ItemProductLink = styled(OptionalProductLink)`
  color: inherit;
  text-decoration: none;
  transition: color 0.15s;
  &:hover {
    color: ${({ theme }) => theme.colors.component.link};
  }
`
